import { ReactNode, useState } from 'react';

import { ArrowsPointingOutIcon } from '@heroicons/react/24/outline';

import { Card } from '@/components/Card';
import { IconButton } from '@/components/IconButton';
import { Modal } from '@/components/Modal';
import { cls } from '@/utils/cls';

export type GraphContainerProps = {
  children: ReactNode;
  className?: string;
  header?: ReactNode;
  title?: string;
  titleClassName?: string;
  titleInfo?: string;
};

export function GraphContainer({ children, className, header, title, titleInfo, titleClassName }: GraphContainerProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const containerClass = cls('relative w-full h-full', className);
  const titleInfoDom = titleInfo ? <span className="text-gray-500 font-normal ml-2">{titleInfo}</span> : null;

  return (
    <div className={containerClass}>
      <Card className="h-full flex flex-col">
        {header ??
          (title ? (
            <h3 className={cls('text-sm font-semibold text-gray-900 pr-6', titleClassName)}>
              {title} {titleInfoDom}
            </h3>
          ) : null)}

        <IconButton
          onClick={() => setIsExpanded(!isExpanded)}
          aria-label="Expand graph"
          className="absolute p-2 top-4 right-4"
        >
          <ArrowsPointingOutIcon className="h-6 w-6" aria-hidden="true" />
        </IconButton>
        {children}
      </Card>
      <Modal title={title} titleInfo={titleInfo} isOpen={isExpanded} onClose={() => setIsExpanded(false)}>
        {children}
      </Modal>
    </div>
  );
}
